export default {
  'resetPassword.title': '重置密码',
  'resetPassword.step.validateEmail': '验证邮箱',
  'resetPassword.step.resetPassword': '重置密码',
  'resetPassword.step.done': '完成',
  'resetPassword.field.email': '邮箱',
  'resetPassword.field.modifyEmail': '更换邮箱',
  'resetPassword.field.phoneNumber': '手机号',
  'resetPassword.field.validateEmail': '验证',
  'resetPassword.field.password': '新密码',
  'resetPassword.field.confirmationPassword': '确认密码',
  'resetPassword.field.code': '验证码',
  'resetPassword.means.email': '邮箱验证码',
  'resetPassword.means.sms': '手机验证码',
  'resetPassword.sendVerifyCode': '发送验证码',
  'resetPassword.resendVerifyCode': '重发验证码',
  'resetPassword.countdown': '{count}秒',
  'resetPassword.reset': '重置密码',
  'resetPassword.chooseVerifyMethod': '选择验证方式',

  'resetPassword.sentVerifyCodeToEmail': '已发送验证码到你的邮箱 {email}',
  'resetPassword.sentVerifyCodeToPhone': '已发送验证码到你的手机号',
  'resetPassword.field.email.required': '邮箱不能为空',
  'resetPassword.field.email.wrong-format': '邮箱格式不正确',
  'resetPassword.field.password.required': '密码不能为空',
  'resetPassword.field.confirmationPassword.required': '确认密码不能为空',
  'resetPassword.field.password.not-match': '两次输入的密码不一致',
  'resetPassword.field.code.required': '验证码不能为空',
  'resetPassword.field.mobile.required': '手机号不能为空',
  'resetPassword.field.pin.empty': '验证码不能为空',
  'resetPassword.field.pin.lengthNotMatch': '验证码必须是{len}位数字',

  'resetPassword.success': '重置密码成功',
  'resetPassword.gotoLogin': '前往登录',
};
